// Undo/redo as whole-map snapshots: maps are small (a few hundred points) and every edit is already a
// new MapData, so there is no inverse operation to get wrong.
import type { MapData } from '../../core/map/schema.js';

export class History {
  private past: MapData[] = [];
  private future: MapData[] = [];
  constructor(private readonly limit = 200) {}

  /** Records the map as it was before an edit; a fresh edit drops the redo branch. */
  push(before: MapData) {
    this.past.push(before);
    if (this.past.length > this.limit) this.past.shift();
    this.future = [];
  }

  undo(current: MapData): MapData | null {
    const prev = this.past.pop();
    if (!prev) return null;
    this.future.push(current);
    return prev;
  }

  redo(current: MapData): MapData | null {
    const next = this.future.pop();
    if (!next) return null;
    this.past.push(current);
    return next;
  }

  clear() { this.past = []; this.future = []; }
  get canUndo() { return this.past.length > 0; }
  get canRedo() { return this.future.length > 0; }
}
